exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.breadcrumb[data-v-21d4c6e0] {\n}\nul[data-v-21d4c6e0] {\n  display: flex;\n  justify-content: left;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\nul > li[data-v-21d4c6e0] {\n  display: flex;\n  float: left;\n  height: 10px;\n  width: auto;\n  color: $default;\n/*  font-weight: bold; */\n  font-size: 1em;\n  cursor: default;\n  align-items: center;\n}\nul > li[data-v-21d4c6e0]:not(:last-child)::after {\n  content: '/';\n  float: right;\n  font-size: .8em;\n  margin: 0 .5em;\n  color: $light-default;\n  cursor: default;\n}\n.linked[data-v-21d4c6e0] {\n  cursor: pointer;\n  font-size: 1em;\n  font-weight: normal;\n  color:#4b8cbb !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21d4c6e0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Breadcrumb.vue
// module id = 515
// module chunks = 0